(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

connectedCallback() {
this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Function to get elements by ID pattern
  function getElementsByIdPattern(pattern) {
    return Array.from(document.querySelectorAll(`[id^="${pattern}"]`));
  }

  // Get all openers and drawers
  const drawerOpeners = getElementsByIdPattern('openNavDrawer-');
  const drawers = getElementsByIdPattern('drawer-custom-menu-');
  const topMenus = getElementsByIdPattern('HeaderMenu-');

  const logoHeader = document.querySelector('.header__heading-logo');

  // Functions to open and close drawers
  function openDrawer(drawer) {
    drawer.classList.add('open');
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('open');
  }

  // setup navigation menu on menu open
  function openMenuDrawer(drawer) {
    drawer.classList.add('menu-open');
  }

  function closeMenuDrawer(drawer) {
    drawer.classList.remove('menu-open');
  }
  //

  // Check if any drawer is open
  function isAnyDrawerOpen() {
    return drawers.some(drawer => drawer.classList.contains('open'));
  }

  // Add event listeners to drawer openers
  drawerOpeners.forEach((drawerOpener, index) => {
    drawerOpener.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isAnyDrawerOpen()) {
        drawers.forEach(drawer => closeDrawer(drawer)); // Close all drawers first
      }
      // setup navigation menu on menu open
      topMenus.forEach(topMenu => openMenuDrawer(topMenu));
      logoHeader.classList.add('menu-open')
      openDrawer(drawers[index]); // Open the clicked drawer
    });
  });

  // Add event listener to document to close drawers when clicking outside
  document.addEventListener('click', function (e) {
    drawers.forEach((drawer, index) => {
      if (!drawer.contains(e.target) && e.target !== drawerOpeners[index]) {
        closeDrawer(drawer);
        // setup navigation menu on menu close
        topMenus.forEach(topMenu => closeMenuDrawer(topMenu));
        logoHeader.classList.remove('menu-open')
      }
    });
  });

  // Prevent event propagation to avoid closing the drawer when clicking inside it
  drawers.forEach(drawer => {
    drawer.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
